import { GridCellParams } from "@mui/x-data-grid";
import { Box, Typography } from "@mui/material";
import { UseRecordsOptions } from "../../api/useRecords";
import { LiveCallCell } from "./LiveCallCell";

export const leadsOptions = {
    fieldsToRemove: {
        fieldTypesToRemove: ["alias"],
        fieldNamesToRemove: ["id"],
    },
    groupsOptions: {
        fieldsWithExtraOptions: [
            {
                field: "client",
                hidden: {
                    create: true,
                },
            },
            {
                field: "clinic",
                relatedTable: "clinics",
                displayTemplate: "{{name}}",
                enabled: true,
                sort: "id",
            },
            {
                field: "diagnose_main",
                sort: "name",
                enabled: true,
            },
            {
                field: "diagnose_secondary_multi",
                relatedTable: "disorders",
                displayTemplate: "{{name}}",
                sort: "name",
                enabled: true,
            },
        ],
    },
    dataGridOptions: {
        extraColumns: {
            beggining: [
                {
                    field: "phone",
                    headerName: "Telemóvel",
                    width: 200,
                    valueGetter: (params: GridCellParams) => params.row.phone ?? "",
                    renderCell: (params: GridCellParams) => (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <Typography variant="body2">{params.row.phone ?? ""}</Typography>
                            <LiveCallCell row={params.row} />
                        </Box>
                    ),
                },
            ],
        },
    },
} as unknown as UseRecordsOptions;
